import React from 'react';
import { motion } from 'framer-motion';
import './ServicesDetail.css';
import img1 from '../assets/Services/3D.png';
import img2 from '../assets/Services/Architecture.jpeg';
import img3 from '../assets/Services/industrial.JPG';
import img4 from '../assets/Services/interior design.jpeg'
import img5 from '../assets/Services/pvc.jpeg';
import img6 from '../assets/Services/turnkey.png';
import img7 from '../assets/Services/Modular.jpeg';
import img8 from '../assets/Services/landscape.jpeg';

const ServicesDetail = ({ onBack }) => {
  const services = [
  {
    id: 'architecture',
    name: 'ARCHITECTURAL DESIGN',
    description: 'We don’t just design buildings—we create meaningful spaces. Our architectural solutions are modern, sustainable, and tailored to meet your vision, ensuring form and function go hand in hand.',
    image: img2
  },
  {
    id: 'interior',
    name: 'INTERIOR DESIGN',
    description: 'Where style meets functionality. Our interior designs reflect your personality, optimize space usage, and transform every room into a place you truly feel at home.',
    image: img4
  },
  {
    id: 'turnkey',
    name: 'TURNKEY PROJECT MANAGEMENT',
    description: 'Sit back and relax—we handle it all. From concept to completion, our turnkey solutions cover every detail of your project, ensuring smooth execution and on-time delivery.',
    image: img6
  },
  {
    id: 'landscape',
    name: 'LANDSCAPE SOLUTIONS',
    description: 'Nature, beautifully integrated. We design green spaces that bring harmony to your environment, adding tranquility, aesthetic value, and a natural balance to your surroundings.',
    image: img8
  },
  {
    id: 'industrial',
    name: 'INDUSTRIAL BUILDINGS',
    description: 'Efficiency meets design. We create industrial facilities that prioritize structural performance, operational flow, and long-term functionality without compromising on aesthetic value.',
    image: img3
  },
  {
    id: '3d',
    name: '3D DESIGNING',
    description: 'Experience your space before it’s built. Our photorealistic 3D renderings allow you to visualize materials, lighting, and layout in detail—bringing your ideas to life with clarity and precision.',
    image: img1

  },
  {
    id: 'modular-furniture',
    name: 'MODULAR FURNITURE',
    description: 'Smart, flexible, and future-ready. Our modular furniture solutions are customizable and space-efficient—perfect for evolving needs and modern lifestyles.',
    image: img7
  },
  {
    id: 'pvc-modular',
    name: 'PVC MODULAR SOLUTIONS',
    description: 'Durable, low-maintenance, and stylish. Our PVC modular designs are ideal for long-lasting, eco-friendly interiors with a sleek, modern finish.',
    image: img5
  },
  
];


  return (
    <section id="services-detail" className="section services-detail">
      <div className="container">
        

        <motion.div 
          className="service-detail-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="service-detail-header">
            <h2>Services We Provide</h2>
          </div>

          <div className="service-detail-grid">
            {services.map((service, index) => (
              <motion.div 
                key={service.id}
                className="service-detail-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              > 
                <div className="service-image">
                <img src={service.image} alt={service.name} />
              </div>
                <h3>{service.name}</h3>
                <p>{service.description}</p>
                
                
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesDetail; 